import {PostExternalProductReadUserBeforeOrderListApiForm, ProductExListElementType, ProductExListMapType, ProductExSearchParamType,} from "../interface";

export const productExSearchParam2Init: ProductExSearchParamType = {
    keyword1: "",
    keywordType1: "1",
    keyword2: "",
    keywordType2: "1",
    limit: 10,
    pageNo: 1
}

export const productExListMapInit: ProductExListMapType = {
    totalCount: 0,
    productList: []
}

export const productExListElementInit: ProductExListElementType = {
    newErpProductid: "",
    vendor: "",
    category: "",
    majorCategory: "",
    subCategory: "",
    new_txt_nm_item: "",
    new_txt_stnd_item: "",
    productExplain: "",
    erpProductImageVO: {}
}

export const productSideSearchParams: PostExternalProductReadUserBeforeOrderListApiForm = {
    limit: 5,
    newErpProductid: "",
    pageNo: 1,
    userId: null,
}